import { render, staticRenderFns } from "./NaoAutorizado.vue?vue&type=template&id=1848cb4a&scoped=true"
import script from "./NaoAutorizado.vue?vue&type=script&lang=js"
export * from "./NaoAutorizado.vue?vue&type=script&lang=js"
import style0 from "./NaoAutorizado.vue?vue&type=style&index=0&id=1848cb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1848cb4a",
  null
  
)

export default component.exports